qtySum = ->
    qAd = document.getElementsByName('qtyAdults')
    qCh = document.getElementsByName('qtyChildren')
    cardQty = document.querySelector('.qtyTotal')
    if qAd.length && qCh.length && cardQty
        tot = 0
        i = 0
        while i < qAd.length
            if parseInt(qAd[i].value)
                tot += parseInt(qAd[i].value)
            i++
        i = 0
        while i < qCh.length
            if parseInt(qCh[i].value)
                tot += parseInt(qCh[i].value)
            i++
        cardQty.innerHTML = tot
    return

qtySum()

$ ->
    'use strict'
    # daterange picker
    defaultDate = new Date()
    $monthly_picker = $('[js-monthly-picker]')
    
    $monthly_picker.each ->
        $(this).datetimepicker
            format: 'MMMM, YYYY'
            showClose: true
            showClear: true
            viewMode: 'months'
            widgetPositioning:
                vertical: 'auto'
                horizontal: 'auto'
            icons:
                time: "fa fa-clock"
                date: "fa fa-calendar"
                up: "fa fa-arrow-up"
                down: "fa fa-arrow-down"
                previous: "fa fa-chevron-left"
                next: "fa fa-chevron-right"
                today: "fa fa-clock"
                clear: "fa fa-trash"

    if $('input[name="dates"]').length > 0 && $('input[name="dates"]').val()
        dates = $('input[name="dates"]').val().split(" > ")
        $('input[name="dates"]').daterangepicker
            orientation: "auto left"
            autoApply: true
            autoUpdateInput: true
            locale:
                format: 'MMM D, YYYY'
                separator: ' > '
            startDate: dates[0]
            endDate: dates[1]
    else
        $('input[name="dates"]').daterangepicker
            orientation: "auto left"
            autoApply: true
            autoUpdateInput: true
            locale:
                format: 'MMM D, YYYY'
                separator: ' > '
            startDate: moment(defaultDate.setDate(defaultDate.getDate() + 7)).format("MMM D, YYYY")
            endDate: moment(defaultDate.setDate(defaultDate.getDate() + 5)).format("MMM D, YYYY")
    $('input[name="dates"]').on 'cancel.daterangepicker', (ev, picker) ->
        $(this).val ''
        return

    $('input.date-auto-update').on 'change', ->
        # console.log(window.location.pathname + "?dates=" + $(this).val())
        window.location.href = window.location.pathname + "?dates=" + $(this).val()
        return


    new WOW({
        boxClass: "scroll_effect"
        callback:
            -> $('div.loading-box').hide() if $('div.loading-box').length
        }).init()

    removeAnimation = ->
        $('.qtyTotal').removeClass 'rotate-x'
        return

    # filters listing
    if $('.isotope-wrapper').length && $('.filters_listing').length
        $('.filters_listing').on 'click', 'input', 'change', ->
            selector = $(this).attr('data-filter')
            $('.isotope-wrapper').isotope filter: selector
            return

    # pricing slider
    applyPriceSlider = ->
        if $('#range').length
            $range_min = 0
            $range_max = 0
            $('div.box_list').each ->
                $range_price = parseFloat $(this).attr('js-rate')
                if $range_price > 0
                    if $range_min == 0 or $range_price < $range_min
                        $range_min = $range_price
                    if $range_max == 0 or $range_price > $range_max
                        $range_max = $range_price
            $('#range').ionRangeSlider
                hide_min_max: true
                keyboard: true
                min: $range_min - 100
                max: $range_max + 100
                from: $range_min
                to: $range_max
                type: 'double'
                step: 100
                prefix: '$ '
                grid: false
            $('body').on 'DOMSubtreeModified', 'span.irs-from', ->
                applyFilters()
                return
            $('body').on 'DOMSubtreeModified', 'span.irs-to', ->
                applyFilters()
                return
        return

    applyPriceSlider()

    $type = $('input[name=type]')
    $boxes = $('div.box_list')
    $type.on "change", ->
       applyFilters()

    applyFilters = ->
        $boxCnt = 0
        if $('span.irs-from').length
            $fromRate = parseFloat $('span.irs-from').html().replace("$ ", "").replace(" ", "")
        else
            $fromRate = 0
        if $('span.irs-to').length
            $toRate = parseFloat $('span.irs-to').html().replace("$ ", "").replace(" ", "")
        else
            $toRate = 0
        $checkPriceRange = $('#range').length
        $boxes.each ->
            $show = 0
            $bedrooms = $(this).attr('js-bedrooms')
            $penthouse = $(this).attr('js-penthouse')
            if $('#range').length
                $rate = parseFloat $(this).attr('js-rate')
            else
                $rate = 0
            $bedrooms_checked = 0
            $type.each ->
                if $(this).is(":checked")
                   $bedrooms_checked = 1
                   switch $(this).val()
                       when "0.5"
                           if $bedrooms == "0.5" and $penthouse != "1"
                               $show = 1
                       when "1"
                           if $bedrooms == "1.0" and $penthouse != "1"
                               $show = 1
                       when "2"
                           if $bedrooms == "2.0" and $penthouse != "1"
                               $show = 1
                       when "2P"
                           if $bedrooms == "2.0" and $penthouse == "1"
                               $show = 1
                       when "3P"
                           if $bedrooms == "3.0" and $penthouse == "1"
                               $show = 1
            if !$bedrooms_checked
                $show = 1
            if $checkPriceRange and $rate > 0
                if $rate < $fromRate or $rate > $toRate
                    $show = 0
            if $show
                $(this).show()
                $(this).css "visibility", "visible"
            else
                $(this).hide()
                $(this).css "visibility", "hidden"
        if $('.isotope-wrapper').length && $('.filters_listing').length
            $('.isotope-wrapper').isotope()
        return

    if $boxes.length
        applyFilters()

    $('.qtyButtons input').after '<div class="qtyInc"></div>'
    $('.qtyButtons input').before '<div class="qtyDec"></div>'
    $('.qtyDec, .qtyInc').on 'click', ->
        `var newVal`
        $button = $(this)
        oldValue = $button.parent().find('input').val()
        if $button.hasClass('qtyInc')
            newVal = parseFloat(oldValue) + 1
        else
            # don't allow decrementing below zero
            if oldValue > 0
                newVal = parseFloat(oldValue) - 1
            else
                newVal = 0
        $button.parent().find('input').val newVal
        qtySum()
        $('.qtyTotal').addClass 'rotate-x'
        return

    counter = document.querySelector('.qtyTotal')
    if counter != null
        counter.addEventListener 'animationend', removeAnimation

    $(window).load ->
        if $('.isotope-wrapper').length && $('.filters_listing').length
            $container = $('.isotope-wrapper')
            $container.isotope
                itemSelector: '.isotope-item'
                layoutMode: 'masonry'
        return

    return


$ ->
		'use strict'
		# Cart management
		$reservationForm = $("#reservation_form")
		$giveWarning = $("[js-give-warning]")
		$deleteFromCartButton = $(".js-delete-from-cart")
		$transport_picker = $('[js-datetime-picker]')
		$month_picker = $('[js-month-picker]')
		$year_picker = $('[js-year-picker]')

		$giveWarning.on 'click', (e) ->
				e.preventDefault()
				alert "This option requires confirmation. Please call us at 1-800-650-8199 to reserve it."
				return

		# Delete from cart handler
		$deleteFromCartButton.on 'click', (e) ->
				e.preventDefault()

				if confirm('Are you sure you want to remove this item from your cart?')
						unitIndex = $(this).attr('data-unit-index')

						# Add hidden input for delete action
						$reservationForm.append('<input type="hidden" name="delete_unit" value="' + unitIndex + '">')

						# Submit form
						$reservationForm.submit()
				return

		# Add to cart from quote handler (AJAX)
		$('.js-add-quote-to-cart').on 'click', (e) ->
				e.preventDefault()

				$button = $(this)
				leadunit_id = $button.data('leadunit-id')
				identifier_code = $button.data('identifier-code')

				# Disable button and show loading state
				$button.prop 'disabled', true
				originalText = $button.html()
				$button.html '<i class="icon-spin1 animate-spin"></i> Adding...'

				# AJAX request to add item to cart
				$.ajax
					url: '/Reservations/addQuoteItemToCart'
					type: 'POST'
					data:
						leadunit_id: leadunit_id
						identifier_code: identifier_code
					dataType: 'json'
					success: (response) ->
						if response.success
							# Update button to show success
							$button.html '<i class="icon-check"></i> Added to Cart!'
							$button.removeClass('btn-success').addClass 'btn-outline-success'

							# Update cart count badge in header
							if response.cart_count
								$cartBadge = $('.cart-menu-btn strong')
								$cartBadge.text response.cart_count
								# Show badge if it was hidden
								if response.cart_count > 0
									$cartBadge.removeClass 'invisible'

							# Show success message
							if $('.alert-container').length
								$('.alert-container').html '<div class="alert alert-success alert-dismissible fade show"><strong>Success!</strong> Item added to cart. <a href="/reservation" class="alert-link">View cart</a><button type="button" class="close" data-dismiss="alert">&times;</button></div>'

							# Re-enable after 2 seconds
							setTimeout ->
								$button.prop 'disabled', false
								return
							, 2000
						else
							# Error response
							$button.html originalText
							$button.prop 'disabled', false
							alert 'Error: ' + (response.message || 'Could not add item to cart')
						return
					error: (xhr, status, error) ->
						# Network or server error
						$button.html originalText
						$button.prop 'disabled', false
						alert 'Error adding item to cart. Please try again.'
						console.error 'Add to cart error:', error
						return
				return

		# submit only once
		$('form#reservation_form').submit ->
				$(this).find(':input[type=submit]').prop 'disabled', true
				$(this).find(':input[type=submit]').val "Please wait"
				return

		# terms and conditions toggle
		$('a#toggle-terms-conditions').on "click", (e) ->
				e.preventDefault()
				$('div#terms-conditions').toggle()
				return

		# hand input values
		$('[js-numbers-only]').on "keypress", (e) ->
				charCode = if e.which then e.which else event.keyCode
				if charCode > 31 and (charCode < 48 or charCode > 57)
						return false
				return true
		$('[js-numbers-only]').on "change", (e) ->
				newValue = @value.replace(new RegExp(/[^\d]/, 'ig'), '')
				@value = newValue
				return

		# transportation update
		$("select[name=trip_type]").on "change", (e) ->
				if $("#trip_type").val()
						openTransportCart()
				else
						closeTransportCart()
				return

		$("input[name=number_of_passengers]").on "change", (e) ->
				figurePrice()
				return

		$("select[name=resort]").on "change", (e) ->
				js_round_standard = $(this).find('option[value="' + $(this).val() + '"]').attr("js-round-standard")
				$('input[name="rt_1_7"]').val(js_round_standard)
				$("#reservation_form").find("[js-rt-1-7]").html("$"+ js_round_standard)
				js_round_large = $(this).find('option[value="' + $(this).val() + '"]').attr("js-round-large")
				$('input[name="rt_8_10"]').val(js_round_large)
				$("#reservation_form").find("[js-rt-8-10]").html("$"+ js_round_large)
				js_round_group = $(this).find('option[value="' + $(this).val() + '"]').attr("js-round-group")
				$('input[name="rt_11_15"]').val(js_round_group)
				$("#reservation_form").find("[js-rt-11-15]").html("$"+ js_round_group)
				js_arrival_standard = $(this).find('option[value="' + $(this).val() + '"]').attr("js-arrival-standard")
				$('input[name="ao_1_7"]').val(js_arrival_standard)
				$("#reservation_form").find("[js-ao-1-7]").html("$"+ js_arrival_standard)
				js_arrival_large = $(this).find('option[value="' + $(this).val() + '"]').attr("js-arrival-large")
				$('input[name="ao_8_10"]').val(js_arrival_large)
				$("#reservation_form").find("[js-ao-8-10]").html("$"+ js_arrival_large)
				js_arrival_group= $(this).find('option[value="' + $(this).val() + '"]').attr("js-arrival-group")
				$('input[name="ao_11_15"]').val(js_arrival_group)
				$("#reservation_form").find("[js-ao-11-15]").html("$"+ js_arrival_group)
				js_departure_standard = $(this).find('option[value="' + $(this).val() + '"]').attr("js-departure-standard")
				$('input[name="do_1_7"]').val(js_departure_standard)
				$("#reservation_form").find("[js-do-1-7]").html("$"+ js_departure_standard)
				js_departure_large = $(this).find('option[value="' + $(this).val() + '"]').attr("js-departure-large")
				$('input[name="do_8_10"]').val(js_departure_large)
				$("#reservation_form").find("[js-do-8-10]").html("$"+ js_departure_large)
				js_departure_group = $(this).find('option[value="' + $(this).val() + '"]').attr("js-departure-group")
				$('input[name="do_11_15"]').val(js_departure_group)
				$("#reservation_form").find("[js-do-11-15]").html("$"+ js_departure_group)
				figurePrice()
				return

		$("input[name=promo_code]").on "change", (e) ->
				$("input[name=promo_code]").attr("js-size", "")
				$("input[name=promo_code]").attr("js-promo", "")
				$("input[name=promo_code]").attr("js-amount", "")
				$("#promo-message").remove()
				$("#token-line-item").addClass("d-none")
				parameters = {
						action: "token-search"
						code: $("input[name=promo_code]").val()
				}
				$.getJSON '/reservation/ajax', parameters
						.done (response) ->
								if response
										$("input[name=promo_code]").attr("js-size", response.size)
										if response.free == true
												$("input[name=promo_code]").attr("js-promo", "free")
										if response.price
												$("input[name=promo_code]").attr("js-promo", "price")
												$("input[name=promo_code]").attr("js-amount", response.price)
										if response.percentage
												$("input[name=promo_code]").attr("js-promo", "percentage")
												$("input[name=promo_code]").attr("js-amount", response.percentage)
										$("#transport-token").html $("input[name=promo_code]").val()
										$("#token-line-item").removeClass("d-none")
										$('#promo-group').append(' <span id="promo-message" class="text-success">Your promo code has been applied.</span>')
								else
										$('#promo-group').append(' <span id="promo-message" class="text-danger">The code you entered cannot be found.</span>')
								figurePrice()
						.fail (e) ->
								$('#promo-group').append(' <span id="promo-message" class="text-danger">There is a problem confirming your code.</span>')
								figurePrice()

		$("input[name^=arrival]").on "change", (e) ->
				checkTripType()
				return

		$("select[name^=arrival]").on "change", (e) ->
				checkTripType()
				return

		$("input[name^=departure]").on "change", (e) ->
				checkTripType()
				return

		$("select[name^=departure]").on "change", (e) ->
				checkTripType()
				return

		currencyFormat = (x) ->
				x.toFixed(2).toString().replace /\B(?=(\d{3})+(?!\d))/g, ','

		openTransportCart = ->
				$('[js-transport-cart]').each ->
						if $(this).hasClass('d-none')
								$(this).removeClass('d-none')
				processTripType()
				figurePrice()
				return

		closeTransportCart = ->
				$('[js-transport-cart]').each ->
						if !$(this).hasClass('d-none')
								$(this).addClass('d-none')
				processTripType()
				return

		processTripType = ->
				if $("#trip_type").val() == "Round trip"
						setProp "#resort"
						setProp "#arrival_airline"
						setProp "#arrival_airline"
						setProp "#arrival_flight"
						setProp "input[name=arrival_datetime]"
						setProp "#departure_airline"
						setProp "#departure_flight"
						setProp "input[name=departure_datetime]"
						setProp "input[name=number_of_passengers]"
						if $("#arrival-info").hasClass('d-none')
								$("#arrival-info").removeClass('d-none')
						if $("#departure-info").hasClass('d-none')
								$("#departure-info").removeClass('d-none')
				else if $("#trip_type").val() == "Arrival only"
						setProp "#resort"
						setProp "#arrival_airline"
						setProp "#arrival_flight"
						setProp "input[name=arrival_datetime]"
						setProp "input[name=number_of_passengers]"
						removeProp "#departure_airline"
						removeProp "#departure_flight"
						removeProp "input[name=departure_datetime]"
						if $("#arrival-info").hasClass('d-none')
								$("#arrival-info").removeClass('d-none')
						if !$("#departure-info").hasClass('d-none')
								$("#departure-info").addClass('d-none')
				else if $("#trip_type").val() == "Departure only"
						setProp "#resort"
						setProp "#arrival_airline"
						setProp "#arrival_flight"
						setProp "input[name=departure_datetime]"
						setProp "input[name=number_of_passengers]"
						removeProp "#arrival_airline"
						removeProp "#arrival_flight"
						removeProp "input[name=arrival_datetime]"
						if !$("#arrival-info").hasClass('d-none')
								$("#arrival-info").addClass('d-none')
						if $("#departure-info").hasClass('d-none')
								$("#departure-info").removeClass('d-none')
				else
						removeProp "#resort"
						removeProp "#arrival_airline"
						removeProp "#arrival_flight"
						removeProp "input[name=arrival_datetime]"
						removeProp "#departure_airline"
						removeProp "#departure_flight"
						removeProp "input[name=departure_datetime]"
						removeProp "input[name=number_of_passengers]"
						if $("#arrival-info").hasClass('d-none')
								$("#arrival-info").removeClass('d-none')
						if $("#departure-info").hasClass('d-none')
								$("#departure-info").removeClass('d-none')
				return

		checkTripType = ->
				if $('select[name=trip_type]').val() == "Round trip"
						openTransportCart()
				else if $('select[name=trip_type]').val() == "Arrival only"
						openTransportCart()
				else if $('select[name=trip_type]').val() == "Departure only"
						openTransportCart()
				else
						closeTransportCart()
				return

		figurePrice = ->
				if $("input[name=number_of_passengers]") && $("input[name=number_of_passengers]").length
						total = 0
						no_of_persons = $("input[name=number_of_passengers]").val()
						$("#transport_type").html $("select[name=trip_type]").val()
						$("#transport_persons").html no_of_persons
						promo = $("input[name=promo_code]").attr('js-promo')
						if ($("input[name=promo_code]").attr('js-size') == "large" && no_of_persons < 7)
								$('#passengers-group').append(' <span class="text-danger">Your promo code is for 1 to 6 people.</span>')
								promo = ""
						if ($("input[name=promo_code]").attr('js-size') == "standard" && no_of_persons > 6)
								$('#passengers-group').append(' <span class="text-danger">Your promo code is for 7 to 10 people.</span>')
								promo = ""
						if ($("input[name=promo_code]").attr('js-size') == "group" && no_of_persons > 10)
								$('#passengers-group').append(' <span class="text-danger">Your promo code is for 11 to 15 people.</span>')
								promo = ""

						transport_resort = $('#reservation_form select[name=resort]').find('option[value="' + $("select[name=resort]").val() + '"]').html()
						$("#transport_resort").html transport_resort

						if $("input[name=number_of_passengers]").val() > 10 
								if $("select[name=trip_type]").val() == "Round trip"
										total = $("input[name=rt_11_15]").val()
								if $("select[name=trip_type]").val() == "Arrival only"
										total = $("input[name=ao_11_15]").val()
								if $("select[name=trip_type]").val() == "Departure only"
										total = $("input[name=do_11_15]").val()
						else if $("input[name=number_of_passengers]").val() > 6
								if $("select[name=trip_type]").val() == "Round trip"
										total = $("input[naHme=rt_8_10]").val()
								if $("select[name=trip_type]").val() == "Arrival only"
										total = $("input[name=ao_8_10]").val()
								if $("select[name=trip_type]").val() == "Departure only"
										total = $("input[name=do_8_10]").val()
						else
								if $("select[name=trip_type]").val() == "Round trip"
										total = $("input[name=rt_1_7]").val()
								if $("select[name=trip_type]").val() == "Arrival only"
										total = $("input[name=ao_1_7]").val()
								if $("select[name=trip_type]").val() == "Departure only"
										total = $("input[name=do_1_7]").val()
						if promo == "free"
								total = 0
						if promo == "percentage"
								total = total - (total / $("input[name=promo_code]").attr('js-amount'))
						if promo == "price"
								total = $("input[name=promo_code]").attr('js-amount')
						$('#transport_total').html "$" + parseFloat(total).toFixed(2)
				return

		setProp = (id_item) ->
				if !$(id_item).prop('required')
						$(id_item).prop('required',true)
				return

		removeProp = (id_item) ->
				if $(id_item).prop('required')
						$(id_item).prop('required',false)
				return

		$(window).load ->
				resform_form =
						if $reservationForm.length
								if $reservationForm.attr('action').indexOf('transportation') > -1
										if	$('select[name="resort"]').val() != ""
												$('select[name="resort"]').change()
				$transport_picker.each ->
						$(this).datetimepicker
								format: 'MMM D, YYYY h:mma'
								showClose: true
								showClear: true
								sideBySide: true
								stepping: 5
								minDate: moment().startOf('day')
								widgetPositioning:
										vertical: 'top'
										horizontal: 'auto'
								icons:
										time: "fa fa-clock"
										date: "fa fa-calendar"
										up: "fa fa-arrow-up"
										down: "fa fa-arrow-down"
										previous: "fa fa-chevron-left"
										next: "fa fa-chevron-right"
										today: "fa fa-clock"
										clear: "fa fa-trash"

				$month_picker.each ->
						$(this).datetimepicker
								format: 'MM'
								showClose: true
								showClear: true
								viewMode: 'months'
								widgetPositioning:
										vertical: 'top'
										horizontal: 'auto'
								icons:
										time: "fa fa-clock"
										date: "fa fa-calendar"
										up: "fa fa-arrow-up"
										down: "fa fa-arrow-down"
										previous: "fa fa-chevron-left"
										next: "fa fa-chevron-right"
										today: "fa fa-clock"
										clear: "fa fa-trash"

				$year_picker.each ->
						$(this).datetimepicker
								format: 'YYYY'
								showClose: true
								showClear: true
								viewMode: 'years'
								widgetPositioning:
										vertical: 'top'
										horizontal: 'auto'
								icons:
										time: "fa fa-clock"
										date: "fa fa-calendar"
										up: "fa fa-arrow-up"
										down: "fa fa-arrow-down"
										previous: "fa fa-chevron-left"
										next: "fa fa-chevron-right"
										today: "fa fa-clock"
										clear: "fa fa-trash"

				return

		return

###*
@license Sticky-kit v1.1.4 | MIT | Leaf Corcoran 2015 | http://leafo.net
###


$ = window.jQuery

win = $ window
doc = $ document

window.jQuery.fn.stick_in_parent = (opts={}) ->
  {
    sticky_class
    inner_scrolling
    recalc_every
    parent: parent_selector
    offset_top
    spacer: manual_spacer
    bottoming: enable_bottoming
  } = opts

  win_height = win.height()
  doc_height = doc.height()

  offset_top ?= 0
  parent_selector ?= undefined
  inner_scrolling ?= true
  sticky_class ?= "is_stuck"

  enable_bottoming = true unless enable_bottoming?

  # we need this because jquery's version (along with css()) rounds everything
  outer_width = (el) ->
    if window.getComputedStyle
      _el = el[0]
      computed = window.getComputedStyle el[0]

      w = parseFloat(computed.getPropertyValue("width")) + parseFloat(computed.getPropertyValue("margin-left")) + parseFloat(computed.getPropertyValue("margin-right"))

      if computed.getPropertyValue("box-sizing") != "border-box"
        w += parseFloat(computed.getPropertyValue("border-left-width")) + parseFloat(computed.getPropertyValue("border-right-width")) + parseFloat(computed.getPropertyValue("padding-left")) + parseFloat(computed.getPropertyValue("padding-right"))
      w
    else
      el.outerWidth true

  for elm in @
    ((elm, padding_bottom, parent_top, parent_height, top, height, el_float, detached) ->
      return if elm.data "sticky_kit"
      elm.data "sticky_kit", true

      last_scroll_height = doc_height

      parent = elm.parent()
      parent = parent.closest(parent_selector) if parent_selector?
      throw "failed to find stick parent" unless parent.length

      fixed = false
      bottomed = false
      spacer = if manual_spacer?
        manual_spacer && elm.closest manual_spacer
      else
        $("<div />")

      spacer.css('position', elm.css('position')) if spacer

      recalc = ->
        return if detached
        win_height = win.height();
        doc_height = doc.height();
        last_scroll_height = doc_height

        border_top = parseInt parent.css("border-top-width"), 10
        padding_top = parseInt parent.css("padding-top"), 10
        padding_bottom = parseInt parent.css("padding-bottom"), 10

        parent_top = parent.offset().top + border_top + padding_top
        parent_height = parent.height()

        if fixed
          fixed = false
          bottomed = false

          unless manual_spacer?
            elm.insertAfter(spacer)
            spacer.detach()

          elm.css({
            position: ""
            top: ""
            width: ""
            bottom: ""
          }).removeClass(sticky_class)

          restore = true

        top = elm.offset().top - (parseInt(elm.css("margin-top"), 10) or 0) - offset_top

        height = elm.outerHeight true

        el_float = elm.css "float"
        spacer.css({
          width: outer_width elm
          height: height
          display: elm.css "display"
          "vertical-align": elm.css "vertical-align"
          "float": el_float
        }) if spacer

        if restore
          tick()

      recalc()
      return if height == parent_height

      last_pos = undefined
      offset = offset_top

      recalc_counter = recalc_every

      tick = ->
        return if detached
        recalced = false

        if recalc_counter?
          recalc_counter -= 1
          if recalc_counter <= 0
            recalc_counter = recalc_every
            recalc()
            recalced = true

        if !recalced && doc_height != last_scroll_height
          recalc()
          recalced = true

        scroll = win.scrollTop()
        if last_pos?
          delta = scroll - last_pos
        last_pos = scroll

        if fixed
          if enable_bottoming
            will_bottom = scroll + height + offset > parent_height + parent_top

            # unbottom
            if bottomed && !will_bottom
              bottomed = false
              elm.css({
                position: "fixed"
                bottom: ""
                top: offset
              }).trigger("sticky_kit:unbottom")

          # unfixing
          if scroll < top
            fixed = false
            offset = offset_top

            unless manual_spacer?
              if el_float == "left" || el_float == "right"
                elm.insertAfter spacer

              spacer.detach()

            css = {
              position: ""
              width: ""
              top: ""
            }
            elm.css(css).removeClass(sticky_class).trigger("sticky_kit:unstick")

          # updated offset
          if inner_scrolling
            if height + offset_top > win_height # bigger than viewport
              unless bottomed
                offset -= delta
                offset = Math.max win_height - height, offset
                offset = Math.min offset_top, offset

                if fixed
                  elm.css {
                    top: offset + "px"
                  }

        else
          # fixing
          if scroll > top
            fixed = true
            css = {
              position: "fixed"
              top: offset
            }

            css.width = if elm.css("box-sizing") == "border-box"
              elm.outerWidth() + "px"
            else
              elm.width() + "px"

            elm.css(css).addClass(sticky_class)

            unless manual_spacer?
              elm.after(spacer)

              if el_float == "left" || el_float == "right"
                spacer.append elm

            elm.trigger("sticky_kit:stick")

        # this is down here because we can fix and bottom in same step when
        # scrolling huge
        if fixed && enable_bottoming
          will_bottom ?= scroll + height + offset > parent_height + parent_top

          # bottomed
          if !bottomed && will_bottom
            # bottomed out
            bottomed = true
            if parent.css("position") == "static"
              parent.css {
                position: "relative"
              }

            elm.css({
              position: "absolute"
              bottom: padding_bottom
              top: "auto"
            }).trigger("sticky_kit:bottom")

      recalc_and_tick = ->
        recalc()
        tick()

      detach = ->
        detached = true
        win.off "touchmove", tick
        win.off "scroll", tick
        win.off "resize", recalc_and_tick

        $(document.body).off "sticky_kit:recalc", recalc_and_tick
        elm.off "sticky_kit:detach", detach
        elm.removeData "sticky_kit"

        elm.css {
          position: ""
          bottom: ""
          top: ""
          width: ""
        }

        parent.position "position", ""

        if fixed
          unless manual_spacer?
            if el_float == "left" || el_float == "right"
              elm.insertAfter spacer
            spacer.remove()

          elm.removeClass sticky_class

      win.on "touchmove", tick
      win.on "scroll", tick
      win.on "resize", recalc_and_tick
      $(document.body).on "sticky_kit:recalc", recalc_and_tick
      elm.on "sticky_kit:detach", detach

      setTimeout tick, 0

    ) $ elm
  @



$ ->
    'use strict'

    formAction = ""

    String::containsAny = String::containsAny or (arr) ->
        i = 0
        while i < arr.length
            if @indexOf(arr[i]) > -1
                return true
            i++
        false

    $('input[type=submit]').on "click", (e) ->
        formAction = $(this).attr('formaction')

    initValidation = ->
        $.validator.setDefaults
            errorElement: 'span'
            errorPlacement: (error, element) ->
                error.addClass 'invalid-feedback'
                # see inline invalid-feedback spans
                # element.closest('.form-group').append error
                return
            highlight: (element, errorClass, validClass) ->
                $(element).addClass 'is-invalid'
                return
            unhighlight: (element, errorClass, validClass) ->
                $(element).removeClass 'is-invalid'
                return

        # unit detail page sidebar
        $('#detail_sidebar_form').validate
            rules:
                email:
                    required: (element) ->
                         return formAction.containsAny [
                            "login"
                            ]
                    email: true
                password:
                    required: (element) ->
                         return formAction.containsAny [
                            "login"
                            ]
                dates:
                    required: (element) ->
                         return formAction.containsAny [
                            "suite"
                            "villas"
                            "process=lead"
                            ]
                qtyAdults:
                    required: (element) ->
                         return formAction.containsAny [
                            "suite"
                            "villas"
                            "process=lead"
                            ]
                     digits: true
                first_name:
                    required: (element) ->
                         return formAction.containsAny [
                            "process=lead"
                            ]
                last_name:
                    required: (element) ->
                         return formAction.containsAny [
                            "process=lead"
                            ]
                lead_email:
                    required: (element) ->
                         return formAction.containsAny [
                            "process=lead"
                            ]
                    email: true
                confirm_email:
                    required: (element) ->
                         return formAction.containsAny [
                            "process=lead"
                            ]
                    equalTo: '[name=lead_email]'
                phone:
                    required: (element) ->
                         return formAction.containsAny [
                            "process=lead"
                            ]
                    phoneUS: true
                captcha:
                    required: (element) ->
                         return formAction.containsAny [
                            "process=lead"
                            ]

    genericValidation = ->
        # Fetch all the forms we want to apply custom Bootstrap validation styles to
        forms = document.getElementsByClassName('needs-validation')
        # Loop over them and prevent submission
        validation = Array::filter.call(forms, (form) ->
            form.addEventListener 'submit', ((event) ->
                if form.checkValidity() == false
                    event.preventDefault()
                    event.stopPropagation()
                form.classList.add 'was-validated'
                return
            ), false
            return
        )
        return


    $(window).load ->
        initValidation()
        genericValidation()
        return

    return
